import { SweetAlertOptions } from 'sweetalert2';

export const swalDesition = (
    title: string,
    text = '',
    confirmButtonText = 'Confirmar',
    cancelButtonText = 'Cancelar',
): SweetAlertOptions => ({
    title,
    text,
    icon: 'question',
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText
});

export const swalSuccess = (title = 'Operación exitosa', text = '', timer = (text === '') ? 2000 : 5000): SweetAlertOptions => ({
    title,
    text,
    icon: 'success',
    showConfirmButton: false,
    timer: (text === '') ? 2000 : 5000
});

export const swalInfo = (title: string, text = '', timer = (text === '') ? 2000 : 3000): SweetAlertOptions => ({
    title,
    text,
    icon: 'info',
    showConfirmButton: false,
    timer: (text === '') ? 2000 : 5000
});

export const swalWarning = (title: string, text = '', timer = (text === '') ? 1500 : 2500): SweetAlertOptions => ({
    title,
    text,
    icon: 'warning',
    showConfirmButton: false,
    timer: (text === '') ? 2000 : 5000
});

export const swalError = (
    title = 'Ha ocurrido un error',
    text = 'Vuelva a intentarlo mas tarde',
    timer = (text === '') ? 2000 : 5000
): SweetAlertOptions => ({
    title,
    text,
    icon: 'error',
    showConfirmButton: false,
    timer
});

export const swalCustom = (
    title: string,
    text = '',
    timer = (text === '') ? 2000 : 3000
    ): SweetAlertOptions => ({
    title,
    html: '<img src="../../../assets/img/logo.png" class="imgP">' +
    '<br><br><div>' + text + '</div>',
    text,
    showConfirmButton: false,
    timer
});

export const swalAccept = (
    title: string,
    text = '',
    confirmButtonText = 'Aceptar'
): SweetAlertOptions => ({
    title,
    text,
    icon: 'success',
    showConfirmButton: true,
    confirmButtonText
});

export const swalNoAdjud = (text = 'Comuníquese con su asesor para más información', title = 'No puede continuar con el proceso', timer = 5000): SweetAlertOptions => ({
    title,
    text,
    icon: 'warning',
    showConfirmButton: false,
    timer
});

export const swalEnEspera = (text: string, title = 'En espera', timer = 5000): SweetAlertOptions => ({
    title,
    text,
    icon: 'info',
    showConfirmButton: false,
    timer
});
